var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavourites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.53 5.98a8.35 8.35 0 0 0-5.96-2.48c-2.07 0-4.03.75-5.57 2.11-3.33-2.88-8.35-2.78-11.49.32C2.9 7.52 2.01 9.65 2 11.92s.87 4.4 2.47 6l9.85 9.88a2.37 2.37 0 0 0 3.36 0l9.85-9.88c3.29-3.29 3.29-8.65 0-11.94zM10.4 9.52c-.64 0-1.23.24-1.67.68A2.42 2.42 0 0 0 8 11.94c0 .55-.45 1-1 1-.56-.01-1-.45-1-1.01 0-1.19.48-2.31 1.33-3.15.81-.81 1.9-1.26 3.07-1.26.55 0 1 .45 1 1 0 .56-.45 1-1 1z",
    fill: "#81A63D",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavourites);
export default __webpack_public_path__ + "static/media/favourites.352f6fe935de939ea00dde077bdc9b79.svg";
export { ForwardRef as ReactComponent };